// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Robitest UI primitives */

.rt-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  font-family: var(--font-sans);
  font-weight: var(--font-medium);
  font-size: var(--text-base);
  line-height: 1;
  cursor: pointer;
  transition: background var(--transition-fast), border-color var(--transition-fast), color var(--transition-fast), box-shadow var(--transition-fast);
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
}

.rt-btn:focus-visible {
  outline: none;
  box-shadow: var(--shadow-focus);
}

.rt-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.rt-btn--sm { height: 32px; padding: 0 12px; font-size: var(--text-sm); }
.rt-btn--md { height: 40px; padding: 0 16px; }
.rt-btn--lg { height: 44px; padding: 0 20px; }
.rt-btn--full { width: 100%; }

.rt-btn--primary {
  background: var(--primary);
  color: #fff;
}
.rt-btn--primary:hover:not(:disabled) { background: var(--primary-hover); }

.rt-btn--secondary {
  background: transparent;
  color: var(--text-primary);
  border-color: var(--border);
}
.rt-btn--secondary:hover:not(:disabled) {
  background: var(--surface-hover);
  border-color: var(--border-strong);
}

.rt-btn--ghost {
  background: transparent;
  color: var(--text-secondary);
}
.rt-btn--ghost:hover:not(:disabled) {
  background: var(--surface-hover);
  color: var(--text-primary);
}

.rt-btn--danger {
  background: var(--danger);
  color: #fff;
}
.rt-btn--danger:hover:not(:disabled) { filter: brightness(1.05); }

.rt-btn__spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255,255,255,0.35);
  border-top-color: #fff;
  border-radius: 50%;
  animation: rt-spin 0.6s linear infinite;
}

.rt-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  color: var(--text-secondary);
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: background var(--transition-fast), color var(--transition-fast);
}
.rt-icon-btn:hover { background: var(--surface-hover); color: var(--text-primary); }
.rt-icon-btn:focus-visible { outline: none; box-shadow: var(--shadow-focus); }
.rt-icon-btn--sm { width: 32px; height: 32px; }
.rt-icon-btn--md { width: 36px; height: 36px; }
.rt-icon-btn--lg { width: 40px; height: 40px; }

/* Metric card */
.rt-metric-card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-xl);
  padding: 14px 16px 16px;
  box-shadow: var(--shadow-xs);
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 108px;
  transition:
    border-color var(--transition-fast),
    box-shadow var(--transition-fast),
    background var(--transition-fast),
    transform var(--transition-fast);
}
.rt-metric-card--clickable { cursor: pointer; }
.rt-metric-card--clickable:hover {
  border-color: color-mix(in srgb, var(--metric-accent, var(--primary)) 40%, var(--border));
  box-shadow: var(--shadow-sm);
}
.rt-metric-card__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.rt-metric-card__meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.rt-metric-card__context {
  font-size: var(--text-xs);
  color: var(--text-muted);
}
.rt-metric-card__label {
  font-size: var(--text-xs);
  font-weight: var(--font-medium);
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-muted);
}
.rt-metric-card__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: var(--radius-md);
  background: var(--primary-muted);
  color: var(--primary);
  flex-shrink: 0;
}
.rt-metric-card__value {
  font-size: 1.625rem;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: -0.03em;
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
}
.rt-metric-card__footer {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.rt-metric-card__trend {
  font-size: var(--text-xs);
  font-weight: var(--font-medium);
}
.rt-metric-card__trend--up { color: var(--success); }
.rt-metric-card__trend--down { color: var(--danger); }
.rt-metric-card__trend-label {
  font-size: var(--text-xs);
  color: var(--text-muted);
}

/* Section card */
.rt-section-card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-xs);
  overflow: hidden;
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
}
.rt-section-card:hover {
  border-color: color-mix(in srgb, var(--primary) 22%, var(--border));
  box-shadow: var(--shadow-sm);
}
.rt-section-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px 0;
}
.rt-section-card__title {
  font-size: var(--text-lg);
  font-weight: var(--font-semibold);
  color: var(--text-primary);
  margin: 0;
}
.rt-section-card__subtitle {
  font-size: var(--text-sm);
  color: var(--text-muted);
  margin: 4px 0 0;
}
.rt-section-card__body { padding: 16px 20px 20px; }

/* Page header */
.rt-page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}
.rt-page-header__title {
  font-size: var(--text-3xl);
  font-weight: var(--font-semibold);
  color: var(--text-primary);
  letter-spacing: -0.02em;
  margin: 0;
  line-height: 1.2;
}
.rt-page-header__subtitle {
  font-size: var(--text-base);
  color: var(--text-secondary);
  margin: 6px 0 0;
}
.rt-page-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.rt-page-header__crumbs {
  font-size: var(--text-sm);
  color: var(--text-muted);
  margin-bottom: 4px;
}

/* Badge */
.rt-badge {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: var(--radius-full);
  font-size: 11px;
  font-weight: var(--font-medium);
  letter-spacing: 0.01em;
  white-space: nowrap;
  text-transform: capitalize;
}
.rt-badge--success { background: var(--success-muted); color: var(--success); }
.rt-badge--danger { background: var(--danger-muted); color: var(--danger); }
.rt-badge--warning { background: var(--warning-muted); color: var(--warning); }
.rt-badge--info { background: var(--info-muted); color: var(--info); }
.rt-badge--muted { background: var(--bg-tertiary); color: var(--text-muted); }

/* Empty / Error / Loading */
.rt-empty-state,
.rt-error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 12px;
  padding: 48px 24px;
  min-height: 280px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  color: var(--text-primary);
}

.rt-empty-state__icon,
.rt-error-state__icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--bg-tertiary);
  color: var(--text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
}

.rt-error-state__icon {
  background: var(--danger-muted);
  color: var(--danger);
}

.rt-empty-state__title,
.rt-error-state__title {
  font-size: var(--text-lg);
  font-weight: var(--font-semibold);
  color: var(--text-primary);
  margin: 0;
}
.rt-empty-state__desc,
.rt-error-state__desc {
  font-size: var(--text-base);
  color: var(--text-secondary);
  max-width: 360px;
  margin: 0 0 12px;
}
.rt-empty-state__action { margin-top: 4px; }

.rt-skeleton {
  display: block;
  background: linear-gradient(90deg, var(--bg-tertiary) 25%, var(--surface-hover) 50%, var(--bg-tertiary) 75%);
  background-size: 200% 100%;
  animation: rt-shimmer 1.4s ease infinite;
  border-radius: var(--radius-sm);
}
.rt-skeleton--rounded { border-radius: var(--radius-full); }
.rt-skeleton--value { width: 72px; height: 28px; }
.rt-loading-state { display: flex; flex-direction: column; gap: 10px; padding: 8px 0; }
.rt-loading-state__row { width: 100%; }

/* Avatar */
.rt-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-full);
  background: var(--primary-muted);
  color: var(--primary);
  font-weight: var(--font-semibold);
  overflow: hidden;
  flex-shrink: 0;
}
.rt-avatar img { width: 100%; height: 100%; object-fit: cover; }
.rt-avatar--sm { width: 28px; height: 28px; font-size: 11px; }
.rt-avatar--md { width: 32px; height: 32px; font-size: 12px; }
.rt-avatar--lg { width: 40px; height: 40px; font-size: 14px; }

/* Progress */
.rt-progress { display: flex; flex-direction: column; gap: 6px; }
.rt-progress__meta {
  display: flex;
  justify-content: space-between;
  font-size: var(--text-sm);
  color: var(--text-secondary);
}
.rt-progress__track {
  height: 8px;
  background: var(--bg-tertiary);
  border-radius: var(--radius-full);
  overflow: hidden;
}
.rt-progress__fill {
  height: 100%;
  background: var(--primary);
  border-radius: var(--radius-full);
  transition: width var(--transition-normal);
}

/* Table */
.rt-table-wrap {
  width: 100%;
  overflow-x: auto;
}
.rt-table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--text-base);
}
.rt-table th {
  text-align: left;
  padding: 10px 14px;
  font-size: var(--text-xs);
  font-weight: var(--font-medium);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-muted);
  border-bottom: 1px solid var(--border);
  background: var(--bg-tertiary);
  white-space: nowrap;
  position: sticky;
  top: 0;
  z-index: 1;
}
.rt-table td {
  padding: 12px 14px;
  border-bottom: 1px solid var(--border-subtle);
  color: var(--text-primary);
  vertical-align: middle;
}
.rt-table tbody tr:hover { background: var(--surface-hover); }
.rt-table__row--clickable { cursor: pointer; }
.rt-table__align-center { text-align: center; }
.rt-table__align-right { text-align: right; }

.rt-filter-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.rt-chart-container {
  position: relative;
  width: 100%;
}

@keyframes rt-spin {
  to { transform: rotate(360deg); }
}
@keyframes rt-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* Pagination */
.rt-pagination {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 0 2px;
  border-top: 1px solid var(--border-subtle);
  margin-top: 12px;
}

.rt-pagination__range {
  font-size: var(--text-sm);
  color: var(--text-muted);
  font-weight: 500;
}

.rt-pagination__controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}

.rt-pagination__size {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: var(--text-sm);
  color: var(--text-muted);
  margin-right: 10px;
}

.rt-pagination__size select {
  height: 32px;
  padding: 0 8px;
  border-radius: var(--radius-md);
  border: 1px solid var(--input-border);
  background: var(--input-background);
  color: var(--text-primary);
  font-size: var(--text-sm);
}

.rt-pagination__btn,
.rt-pagination__page {
  min-width: 34px;
  height: 34px;
  padding: 0 10px;
  border-radius: 999px;
  border: 1px solid transparent;
  background: transparent;
  color: var(--text-secondary);
  font-size: var(--text-sm);
  font-weight: 550;
  cursor: pointer;
  transition: background 150ms ease, border-color 150ms ease, color 150ms ease, box-shadow 150ms ease;
}

.rt-pagination__btn:hover:not(:disabled),
.rt-pagination__page:hover:not(:disabled) {
  background: var(--surface-hover, rgba(15, 23, 42, 0.04));
  color: var(--text-primary);
}

.rt-pagination__btn:disabled,
.rt-pagination__page:disabled {
  opacity: 0.38;
  cursor: not-allowed;
}

.rt-pagination__page--active {
  background: var(--primary-muted);
  border-color: transparent;
  color: var(--primary);
  font-weight: 650;
  box-shadow: none;
}

.rt-pagination__page--active:hover:not(:disabled) {
  background: var(--primary-muted);
  color: var(--primary);
}

.rt-pagination__pages {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.rt-pagination__ellipsis {
  min-width: 24px;
  text-align: center;
  color: var(--text-muted);
  font-size: var(--text-sm);
}

/* Row actions + overflow menu */
.rt-row-actions {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  opacity: 0.85;
}

.rt-data-table__row--clickable:hover .rt-row-actions,
.rt-data-table tbody tr:hover .rt-row-actions {
  opacity: 1;
}

.rt-action-menu {
  position: fixed;
  z-index: 1200;
  min-width: 240px;
  max-width: 300px;
  padding: 6px;
  background: var(--surface-raised, var(--surface, #fff));
  border: 1px solid var(--border, #e2e8f0);
  border-radius: var(--radius-lg, 10px);
  box-shadow: var(--shadow-md, 0 4px 12px rgba(15, 23, 42, 0.08));
  color: var(--text-primary, #0f172a);
  -webkit-font-smoothing: antialiased;
}

[data-theme='dark'] .rt-action-menu {
  background: var(--surface-raised, #101d30);
  border-color: var(--border, #1d3149);
  color: var(--text-primary, #f8fafc);
  box-shadow: var(--shadow-md, 0 8px 24px rgba(0, 0, 0, 0.4));
}

/* One surface only — children never paint their own boxes */
.rt-action-menu *,
.rt-action-menu *::before,
.rt-action-menu *::after {
  text-shadow: none;
  box-shadow: none;
}

.rt-action-menu__item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  text-align: left;
  padding: 9px 10px;
  margin: 0;
  border: none;
  border-radius: var(--radius-md, 8px);
  background: transparent;
  color: inherit;
  font-size: var(--text-sm, 0.875rem);
  font-family: inherit;
  cursor: pointer;
  appearance: none;
}

.rt-action-menu__item:hover:not(:disabled),
.rt-action-menu__item:focus-visible:not(:disabled) {
  background: rgba(59, 130, 246, 0.08);
  outline: none;
}

[data-theme='dark'] .rt-action-menu__item:hover:not(:disabled),
[data-theme='dark'] .rt-action-menu__item:focus-visible:not(:disabled) {
  background: rgba(59, 130, 246, 0.12);
}

.rt-action-menu__item:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.rt-action-menu__item--danger {
  color: var(--danger, #dc2626);
}

[data-theme='dark'] .rt-action-menu__item--danger {
  color: #fb7185;
}

.rt-action-menu__item--danger:hover:not(:disabled) {
  background: var(--danger-muted, rgba(220, 38, 38, 0.12));
}

.rt-action-menu__icon {
  display: inline-flex;
  flex-shrink: 0;
  margin-top: 2px;
  color: var(--text-muted, #64748b);
  background: transparent;
  border: none;
}

.rt-action-menu__item--danger .rt-action-menu__icon {
  color: inherit;
}

.rt-action-menu__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  background: transparent;
  border: none;
  padding: 0;
}

.rt-action-menu__label {
  font-weight: 600;
  line-height: 1.3;
  background: transparent;
  border: none;
  padding: 0;
}

.rt-action-menu__desc {
  font-size: 11px;
  font-weight: 400;
  color: var(--text-muted, #64748b);
  line-height: 1.35;
  background: transparent;
  border: none;
  padding: 0;
}

.rt-action-menu__divider {
  height: 1px;
  margin: 5px 8px;
  background: var(--border-subtle, var(--border, #e2e8f0));
  border: none;
  box-shadow: none;
}

[data-theme='dark'] .rt-action-menu__divider {
  background: var(--border, #1d3149);
}

/* Flat typography — no accidental text glow across product UI */
.rt2-main,
.rt2-main *,
.rt-action-menu,
.rt-action-menu *,
[data-rt-modal-overlay],
[data-rt-modal-overlay] * {
  text-shadow: none;
}

/* Text wrappers never invent their own surface */
.rt2-main p,
.rt2-main h1,
.rt2-main h2,
.rt2-main h3,
.rt2-main h4,
.rt2-main h5,
.rt2-main h6,
.rt2-main label,
.rt2-main small,
.rt2-main strong,
.rt2-main em,
.rt2-main li {
  background: transparent;
  box-shadow: none;
}
/* Context summary strip */
.rt-context-strip {
  display: grid;
  grid-template-columns: minmax(180px, 1.4fr) repeat(auto-fit, minmax(100px, 1fr));
  gap: 12px;
  padding: 14px 16px;
  margin-bottom: 14px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  align-items: center;
}

.rt-context-strip__title {
  margin: 0;
  font-size: var(--text-lg);
  font-weight: 600;
  color: var(--text-primary);
}

.rt-context-strip__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
}

.rt-context-strip__stat-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-muted);
  font-weight: 600;
}

.rt-context-strip__stat-value {
  font-size: 1.15rem;
  font-weight: 650;
  color: var(--text-primary);
  letter-spacing: -0.02em;
}

/* Filter chips */
.rt-filter-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 8px 0 4px;
}

.rt-filter-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  background: var(--primary-muted);
  color: var(--primary);
  font-size: var(--text-xs);
  font-weight: 600;
  border: none;
}

.rt-filter-chip button {
  border: none;
  background: transparent;
  color: inherit;
  cursor: pointer;
  padding: 0;
  font-size: 14px;
  line-height: 1;
}

.rt-table-skeleton td {
  padding: 12px 10px;
}

.rt-table-skeleton .rt-skeleton {
  height: 14px;
  width: 100%;
}


/* ── Select (canonical custom select) ─────────────────────────────── */
.rt-select {
  position: relative;
  display: inline-flex;
  flex: 0 0 auto;
  min-width: 140px;
  max-width: 100%;
  width: auto;
  vertical-align: middle;
}

/* Compact selects inside FilterBar / toolbars — stay on one row with search */
.rt-select--filter {
  flex: 0 0 auto;
  width: auto;
  min-width: 132px;
  max-width: 200px;
}

.rt-filter-bar > .rt-select,
.rt-filter-bar > .rt-select--filter {
  flex: 0 0 auto;
  width: auto;
  max-width: 200px;
}

.rt-filter-bar > .rt-search {
  flex: 1 1 220px;
  max-width: 360px;
  min-width: 180px;
}

.rt-select--form {
  display: flex;
  width: 100%;
  max-width: none;
}

.rt-select__trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  height: var(--control-height, 36px);
  padding: 0 10px 0 12px;
  border: 1px solid var(--input-border);
  border-radius: var(--radius-md);
  background: var(--input-background);
  color: var(--text-primary);
  font: inherit;
  font-size: var(--text-sm);
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: border-color var(--duration-fast, 120ms) ease, box-shadow var(--duration-fast, 120ms) ease,
    background var(--duration-fast, 120ms) ease;
}

.rt-select--form .rt-select__trigger {
  height: 40px;
  font-weight: 400;
  font-size: var(--text-base);
}

.rt-select--sm .rt-select__trigger {
  height: var(--control-height-sm, 30px);
  padding: 0 6px 0 10px;
}

.rt-select--sm {
  min-width: 72px;
}

.rt-select__trigger:hover:not(:disabled) {
  border-color: var(--border-strong);
}

.rt-select__trigger:focus-visible,
.rt-select.is-open .rt-select__trigger {
  outline: none;
  border-color: var(--primary);
  box-shadow: var(--shadow-focus);
}

.rt-select.is-invalid .rt-select__trigger {
  border-color: var(--danger);
}

.rt-select__trigger:disabled {
  cursor: not-allowed;
  background: var(--surface-disabled);
  color: var(--text-muted);
}

.rt-select__value {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rt-select__value.is-placeholder {
  color: var(--text-muted);
}

.rt-select__chevron {
  flex-shrink: 0;
  color: var(--text-muted);
  transition: transform var(--duration-normal, 200ms) var(--ease-out, ease);
}

.rt-select.is-open .rt-select__chevron {
  transform: rotate(180deg);
}

.rt-select__menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  /* For in-flow menus, match trigger. Portaled menus must NOT use
     min-width: 100% — fixed positioning resolves % against the viewport. */
  min-width: 100%;
  box-sizing: border-box;
  z-index: var(--z-dropdown, 1200);
  margin: 0;
  padding: 4px;
  list-style: none;
  max-height: 300px;
  overflow-y: auto;
  background: var(--surface-elevated);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  animation: rt-pop-in var(--duration-fast, 120ms) var(--ease-out, ease);
}

.rt-select__menu.is-up:not(.rt-select__menu--portal) {
  top: auto;
  bottom: calc(100% + 4px);
}

.rt-select__menu--portal {
  position: fixed;
  z-index: 10050;
  /* width / minWidth come from inline style measured against the trigger */
  min-width: 0;
  max-width: min(100vw - 16px, 480px);
}

.rt-select__option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-height: 34px;
  padding: 6px 10px;
  border-radius: var(--radius-sm);
  font-size: var(--text-sm);
  color: var(--text-primary);
  cursor: pointer;
  white-space: nowrap;
}

.rt-select__option.is-active {
  background: var(--surface-hover);
}

.rt-select__option.is-selected {
  color: var(--primary);
  font-weight: 600;
}

.rt-select__option.is-placeholder {
  color: var(--text-muted);
}

.rt-select__option[aria-disabled='true'] {
  opacity: 0.5;
  cursor: not-allowed;
}

.rt-select__option-hint {
  font-size: 11px;
  color: var(--text-muted);
}

.rt-select__empty {
  padding: 10px;
  font-size: var(--text-sm);
  color: var(--text-muted);
}

@keyframes rt-pop-in {
  from { opacity: 0; transform: translateY(-3px) scale(0.985); }
  to { opacity: 1; transform: none; }
}

/* ── Action menu sections ─────────────────────────────────────────── */
.rt-action-menu {
  z-index: 10050;
  animation: rt-pop-in var(--duration-fast, 120ms) var(--ease-out, ease);
  background: var(--surface-elevated);
  box-shadow: var(--shadow-lg);
}

[data-theme='dark'] .rt-action-menu {
  background: var(--surface-elevated);
  box-shadow: var(--shadow-lg);
}

.rt-action-menu__group {
  padding: 6px 10px 4px;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.rt-action-menu__item:focus-visible {
  outline: none;
  box-shadow: inset 0 0 0 2px var(--primary-muted) !important;
}

/* ── Empty / error states ─────────────────────────────────────────── */
.rt-state__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin-bottom: 4px;
  border-radius: 12px;
  background: var(--bg-tertiary);
  color: var(--text-muted);
  border: 1px solid var(--border-subtle);
}

.rt-state--error .rt-state__icon {
  background: var(--danger-muted);
  color: var(--danger);
  border-color: transparent;
}

/* ── Pagination refinements ───────────────────────────────────────── */
.rt-pagination__btn,
.rt-pagination__page {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-variant-numeric: tabular-nums;
}

.rt-pagination__range {
  font-variant-numeric: tabular-nums;
}

.rt-pagination__btn:focus-visible,
.rt-pagination__page:focus-visible {
  outline: none;
  box-shadow: var(--shadow-focus);
  border-color: var(--primary);
}

@media (max-width: 640px) {
  .rt-pagination {
    flex-direction: column;
    align-items: stretch;
  }

  .rt-pagination__controls {
    justify-content: space-between;
  }

  .rt-pagination__btn[aria-label='First page'],
  .rt-pagination__btn[aria-label='Last page'] {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .rt-select__menu,
  .rt-action-menu,
  .rt-select__chevron {
    animation: none;
    transition: none;
  }
}

/* ── Utilities ─────────────────────────────────────────── */
.rt-visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}

.rt-num { font-variant-numeric: tabular-nums; }

.rt-spin { animation: rt-spin 0.9s linear infinite; }
@keyframes rt-spin { to { transform: rotate(360deg); } }

.rt-btn > svg { vertical-align: -2px; }

/* ── Sortable table header ─────────────────────────────── */
.rt-sort-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 4px;
  margin: -2px -4px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
  cursor: pointer;
}
.rt-sort-btn svg { opacity: 0.35; transition: opacity var(--transition-fast); }
.rt-sort-btn:hover { color: var(--text-primary); background: var(--surface-hover); }
.rt-sort-btn:hover svg,
.rt-sort-btn--active svg { opacity: 1; }
.rt-sort-btn--active { color: var(--primary); }
.rt-sort-btn:focus-visible { outline: 2px solid var(--primary); outline-offset: 1px; }

/* ── Filter chips ──────────────────────────────────────── */
.rt-chip-group {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 6px;
}
.rt-chip {
  --chip-accent: var(--primary);
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  padding: 0 10px;
  border: 1px solid var(--border);
  border-radius: 999px;
  background: var(--surface);
  color: var(--text-secondary);
  font-size: 12.5px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color var(--transition-fast), background var(--transition-fast), color var(--transition-fast);
}
.rt-chip--passed { --chip-accent: var(--success); }
.rt-chip--failed { --chip-accent: var(--danger); }
.rt-chip--running { --chip-accent: var(--info); }
.rt-chip:hover { border-color: color-mix(in srgb, var(--chip-accent) 45%, var(--border)); color: var(--text-primary); }
.rt-chip--active {
  border-color: color-mix(in srgb, var(--chip-accent) 60%, transparent);
  background: color-mix(in srgb, var(--chip-accent) 12%, var(--surface));
  color: var(--text-primary);
}
.rt-chip:focus-visible { outline: 2px solid var(--chip-accent); outline-offset: 2px; }
.rt-chip__dot { width: 7px; height: 7px; border-radius: 50%; background: var(--chip-accent); }
.rt-chip__count {
  min-width: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--surface-hover, rgba(148, 163, 184, 0.14));
  font-size: 11px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
  font-variant-numeric: tabular-nums;
}
.rt-chip--active .rt-chip__count { background: color-mix(in srgb, var(--chip-accent) 22%, transparent); }
.rt-chip--scheduled { --chip-accent: var(--info); }
.rt-chip--pending { --chip-accent: var(--warning); }
.rt-chip--completed { --chip-accent: var(--success); }
.rt-chip--cancelled { --chip-accent: var(--text-muted); }

/* ── Schedules ─────────────────────────────────────────── */
.rt-sched-panel { display: grid; gap: 12px; }
.rt-sched-panel__actions { display: flex; justify-content: flex-end; gap: 8px; }
.rt-sched-table { display: grid; gap: 12px; transition: opacity 150ms ease; }
.rt-sched-table[aria-busy='true'] { opacity: 0.6; }
.rt-sched-name,
.rt-sched-time { display: grid; gap: 2px; min-width: 0; }
.rt-sched-name__title { font-weight: 600; color: var(--text-primary); }
.rt-sched-sub {
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: var(--text-xs, 12px);
  color: var(--text-muted);
}
.rt-sched-sub--plain { font-size: inherit; color: var(--text-secondary); }
@media (prefers-reduced-motion: reduce) {
  .rt-sched-table { transition: none; }
}

/* ── Test result bar ───────────────────────────────────── */
.rt-result { display: grid; gap: 5px; min-width: 150px; }
.rt-result__bar {
  display: flex;
  height: 6px;
  border-radius: 999px;
  overflow: hidden;
  background: var(--border);
}
.rt-result__seg { height: 100%; transition: width var(--duration-slow, 280ms) var(--ease-out, ease-out); }
.rt-result__seg--pass { background: var(--success); }
.rt-result__seg--fail { background: var(--danger); }
.rt-result__seg--skip { background: var(--warning); }
.rt-result__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 2px 8px;
  font-size: 11.5px;
  font-variant-numeric: tabular-nums;
}
.rt-result__pass { color: var(--success); font-weight: 600; }
.rt-result__fail { color: var(--danger); font-weight: 600; }
.rt-result__zero { color: var(--text-muted); }
.rt-result__total { color: var(--text-muted); }
.rt-result__rate { margin-left: auto; font-weight: 600; color: var(--text-primary); }

/* ── Executions table ──────────────────────────────────── */
.rt-exec-name__title { font-weight: 600; }
.rt-exec-updated { font-size: 12px; align-self: center; }
.rt-exec-open {
  display: inline-flex;
  color: var(--text-muted);
  opacity: 0;
  transform: translateX(-4px);
  transition: opacity var(--transition-fast), transform var(--transition-fast), color var(--transition-fast);
}
.rt-data-table__row--clickable:hover .rt-exec-open {
  opacity: 1;
  transform: none;
  color: var(--primary);
}
.rt-exec-status--live .rt-status-dot { animation: rt-live-pulse 1.4s ease-in-out infinite; }
@keyframes rt-live-pulse {
  0%, 100% { box-shadow: 0 0 0 0 color-mix(in srgb, currentColor 45%, transparent); }
  50% { box-shadow: 0 0 0 4px transparent; }
}

.rt-metric-card.rt-metric-card--active {
  border-color: color-mix(in srgb, var(--metric-accent, var(--primary)) 65%, transparent);
  background: color-mix(in srgb, var(--metric-accent, var(--primary)) 7%, var(--surface));
}
.rt-metric-card--pulse .rt-metric-card__value::after {
  content: '';
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-left: 8px;
  border-radius: 50%;
  background: var(--metric-accent);
  vertical-align: middle;
  animation: rt-live-pulse 1.4s ease-in-out infinite;
  color: var(--metric-accent);
}

@media (prefers-reduced-motion: reduce) {
  .rt-spin,
  .rt-exec-status--live .rt-status-dot,
  .rt-metric-card--pulse .rt-metric-card__value::after { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/ui.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,6BAA6B;EAC7B,+BAA+B;EAC/B,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,mJAAmJ;EACnJ,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,cAAc,YAAY,EAAE,eAAe,EAAE,yBAAyB,EAAE;AACxE,cAAc,YAAY,EAAE,eAAe,EAAE;AAC7C,cAAc,YAAY,EAAE,eAAe,EAAE;AAC7C,gBAAgB,WAAW,EAAE;;AAE7B;EACE,0BAA0B;EAC1B,WAAW;AACb;AACA,wCAAwC,gCAAgC,EAAE;;AAE1E;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA,uCAAuC,wBAAwB,EAAE;;AAEjE;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,+BAA+B;EAC/B,eAAe;EACf,2EAA2E;AAC7E;AACA,qBAAqB,gCAAgC,EAAE,0BAA0B,EAAE;AACnF,6BAA6B,aAAa,EAAE,+BAA+B,EAAE;AAC7E,mBAAmB,WAAW,EAAE,YAAY,EAAE;AAC9C,mBAAmB,WAAW,EAAE,YAAY,EAAE;AAC9C,mBAAmB,WAAW,EAAE,YAAY,EAAE;;AAE9C,gBAAgB;AAChB;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB;;;;oCAIkC;AACpC;AACA,6BAA6B,eAAe,EAAE;AAC9C;EACE,yFAAyF;EACzF,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,gCAAgC;EAChC,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;AACA,6BAA6B,qBAAqB,EAAE;AACpD,+BAA+B,oBAAoB,EAAE;AACrD;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,kFAAkF;AACpF;AACA;EACE,mEAAmE;EACnE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,0BAA0B;EAC1B,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;AACjB;AACA,yBAAyB,uBAAuB,EAAE;;AAElD,gBAAgB;AAChB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,0BAA0B;EAC1B,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,+BAA+B;EAC/B,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;AAC5B;AACA,qBAAqB,gCAAgC,EAAE,qBAAqB,EAAE;AAC9E,oBAAoB,+BAA+B,EAAE,oBAAoB,EAAE;AAC3E,qBAAqB,gCAAgC,EAAE,qBAAqB,EAAE;AAC9E,kBAAkB,6BAA6B,EAAE,kBAAkB,EAAE;AACrE,mBAAmB,8BAA8B,EAAE,wBAAwB,EAAE;;AAE7E,4BAA4B;AAC5B;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;;EAEE,yBAAyB;EACzB,iCAAiC;EACjC,0BAA0B;EAC1B,SAAS;AACX;AACA;;EAEE,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;AACA,0BAA0B,eAAe,EAAE;;AAE3C;EACE,cAAc;EACd,4GAA4G;EAC5G,0BAA0B;EAC1B,wCAAwC;EACxC,+BAA+B;AACjC;AACA,wBAAwB,iCAAiC,EAAE;AAC3D,sBAAsB,WAAW,EAAE,YAAY,EAAE;AACjD,oBAAoB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,cAAc,EAAE;AACtF,yBAAyB,WAAW,EAAE;;AAEtC,WAAW;AACX;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,gCAAgC;EAChC,qBAAqB;EACrB,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;AAChB;AACA,iBAAiB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;AAC/D,iBAAiB,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE;AAC7D,iBAAiB,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE;AAC7D,iBAAiB,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE;;AAE7D,aAAa;AACb,eAAe,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAChE;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,8BAA8B;EAC9B,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,0BAA0B;EAC1B,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA,UAAU;AACV;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,sCAAsC;EACtC,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,0BAA0B;EAC1B,sBAAsB;AACxB;AACA,2BAA2B,gCAAgC,EAAE;AAC7D,4BAA4B,eAAe,EAAE;AAC7C,0BAA0B,kBAAkB,EAAE;AAC9C,yBAAyB,iBAAiB,EAAE;;AAE5C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;AACA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,qCAAqC;EACrC,mCAAmC;EACnC,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,uBAAuB;EACvB,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,mGAAmG;AACrG;;AAEA;;EAEE,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,aAAa;AACf;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,uDAAuD;EACvD,wCAAwC;EACxC,qCAAqC;EACrC,+DAA+D;EAC/D,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;EACpC,mCAAmC;EACnC,2DAA2D;AAC7D;;AAEA,4DAA4D;AAC5D;;;EAGE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;EACvB,cAAc;EACd,mCAAmC;EACnC,oBAAoB;EACpB,eAAe;EAEf,gBAAgB;AAClB;;AAEA;;EAEE,oCAAoC;EACpC,aAAa;AACf;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,eAAe;EACf,wDAAwD;EACxD,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,gEAAgE;AAChE;;;;;;EAME,iBAAiB;AACnB;;AAEA,iDAAiD;AACjD;;;;;;;;;;;;EAYE,uBAAuB;EACvB,gBAAgB;AAClB;AACA,0BAA0B;AAC1B;EACE,aAAa;EACb,gFAAgF;EAChF,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,gCAAgC;EAChC,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;;AAGA,wEAAwE;AACxE;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA,8EAA8E;AAC9E;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,mCAAmC;EACnC,sBAAsB;EACtB,qCAAqC;EACrC,+BAA+B;EAC/B,mCAAmC;EACnC,0BAA0B;EAC1B,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf;+CAC6C;AAC/C;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;EACb,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,yEAAyE;AAC3E;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP;2EACyE;EACzE,eAAe;EACf,sBAAsB;EACtB,gCAAgC;EAChC,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,sEAAsE;AACxE;;AAEA;EACE,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yEAAyE;EACzE,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,OAAO,UAAU,EAAE,wCAAwC,EAAE;EAC7D,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;;AAEA,wEAAwE;AACxE;EACE,cAAc;EACd,sEAAsE;EACtE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,2DAA2D;AAC7D;;AAEA,wEAAwE;AACxE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA,wEAAwE;AACxE;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;EACb,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;;;IAGE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,UAAU,kCAAkC,EAAE;;AAE9C,WAAW,uCAAuC,EAAE;AACpD,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;;AAEvD,gBAAgB,oBAAoB,EAAE;;AAEtC,6DAA6D;AAC7D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;AACA,mBAAmB,aAAa,EAAE,0CAA0C,EAAE;AAC9E,qBAAqB,0BAA0B,EAAE,gCAAgC,EAAE;AACnF;2BAC2B,UAAU,EAAE;AACvC,uBAAuB,qBAAqB,EAAE;AAC9C,6BAA6B,iCAAiC,EAAE,mBAAmB,EAAE;;AAErF,6DAA6D;AAC7D;EACE,oBAAoB;EACpB,eAAe;EACf,QAAQ;AACV;AACA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,oBAAoB;EACpB,0BAA0B;EAC1B,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gHAAgH;AAClH;AACA,mBAAmB,6BAA6B,EAAE;AAClD,mBAAmB,4BAA4B,EAAE;AACjD,oBAAoB,0BAA0B,EAAE;AAChD,iBAAiB,uEAAuE,EAAE,0BAA0B,EAAE;AACtH;EACE,qEAAqE;EACrE,sEAAsE;EACtE,0BAA0B;AAC5B;AACA,yBAAyB,qCAAqC,EAAE,mBAAmB,EAAE;AACrF,gBAAgB,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,8BAA8B,EAAE;AAC7F;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;AACpC;AACA,mCAAmC,mEAAmE,EAAE;AACxG,sBAAsB,0BAA0B,EAAE;AAClD,oBAAoB,6BAA6B,EAAE;AACnD,sBAAsB,6BAA6B,EAAE;AACrD,sBAAsB,gCAAgC,EAAE;;AAExD,6DAA6D;AAC7D,kBAAkB,aAAa,EAAE,SAAS,EAAE;AAC5C,2BAA2B,aAAa,EAAE,yBAAyB,EAAE,QAAQ,EAAE;AAC/E,kBAAkB,aAAa,EAAE,SAAS,EAAE,8BAA8B,EAAE;AAC5E,oCAAoC,YAAY,EAAE;AAClD;iBACiB,aAAa,EAAE,QAAQ,EAAE,YAAY,EAAE;AACxD,wBAAwB,gBAAgB,EAAE,0BAA0B,EAAE;AACtE;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,wBAAwB;AAC1B;AACA,uBAAuB,kBAAkB,EAAE,4BAA4B,EAAE;AACzE;EACE,kBAAkB,gBAAgB,EAAE;AACtC;;AAEA,6DAA6D;AAC7D,aAAa,aAAa,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AACxD;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA,kBAAkB,YAAY,EAAE,uEAAuE,EAAE;AACzG,wBAAwB,0BAA0B,EAAE;AACpD,wBAAwB,yBAAyB,EAAE;AACnD,wBAAwB,0BAA0B,EAAE;AACpD;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;AACpC;AACA,mBAAmB,qBAAqB,EAAE,gBAAgB,EAAE;AAC5D,mBAAmB,oBAAoB,EAAE,gBAAgB,EAAE;AAC3D,mBAAmB,wBAAwB,EAAE;AAC7C,oBAAoB,wBAAwB,EAAE;AAC9C,mBAAmB,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;;AAEpF,6DAA6D;AAC7D,uBAAuB,gBAAgB,EAAE;AACzC,mBAAmB,eAAe,EAAE,kBAAkB,EAAE;AACxD;EACE,oBAAoB;EACpB,wBAAwB;EACxB,UAAU;EACV,2BAA2B;EAC3B,0GAA0G;AAC5G;AACA;EACE,UAAU;EACV,eAAe;EACf,qBAAqB;AACvB;AACA,uCAAuC,kDAAkD,EAAE;AAC3F;EACE,WAAW,qEAAqE,EAAE;EAClF,MAAM,iCAAiC,EAAE;AAC3C;;AAEA;EACE,uFAAuF;EACvF,uFAAuF;AACzF;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;EACtB,kDAAkD;EAClD,2BAA2B;AAC7B;;AAEA;EACE;;yDAEuD,eAAe,EAAE;AAC1E","sourcesContent":["/* Robitest UI primitives */\n\n.rt-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border: 1px solid transparent;\n  border-radius: var(--radius-md);\n  font-family: var(--font-sans);\n  font-weight: var(--font-medium);\n  font-size: var(--text-base);\n  line-height: 1;\n  cursor: pointer;\n  transition: background var(--transition-fast), border-color var(--transition-fast), color var(--transition-fast), box-shadow var(--transition-fast);\n  white-space: nowrap;\n  user-select: none;\n}\n\n.rt-btn:focus-visible {\n  outline: none;\n  box-shadow: var(--shadow-focus);\n}\n\n.rt-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.rt-btn--sm { height: 32px; padding: 0 12px; font-size: var(--text-sm); }\n.rt-btn--md { height: 40px; padding: 0 16px; }\n.rt-btn--lg { height: 44px; padding: 0 20px; }\n.rt-btn--full { width: 100%; }\n\n.rt-btn--primary {\n  background: var(--primary);\n  color: #fff;\n}\n.rt-btn--primary:hover:not(:disabled) { background: var(--primary-hover); }\n\n.rt-btn--secondary {\n  background: transparent;\n  color: var(--text-primary);\n  border-color: var(--border);\n}\n.rt-btn--secondary:hover:not(:disabled) {\n  background: var(--surface-hover);\n  border-color: var(--border-strong);\n}\n\n.rt-btn--ghost {\n  background: transparent;\n  color: var(--text-secondary);\n}\n.rt-btn--ghost:hover:not(:disabled) {\n  background: var(--surface-hover);\n  color: var(--text-primary);\n}\n\n.rt-btn--danger {\n  background: var(--danger);\n  color: #fff;\n}\n.rt-btn--danger:hover:not(:disabled) { filter: brightness(1.05); }\n\n.rt-btn__spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255,255,255,0.35);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: rt-spin 0.6s linear infinite;\n}\n\n.rt-icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: transparent;\n  color: var(--text-secondary);\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: background var(--transition-fast), color var(--transition-fast);\n}\n.rt-icon-btn:hover { background: var(--surface-hover); color: var(--text-primary); }\n.rt-icon-btn:focus-visible { outline: none; box-shadow: var(--shadow-focus); }\n.rt-icon-btn--sm { width: 32px; height: 32px; }\n.rt-icon-btn--md { width: 36px; height: 36px; }\n.rt-icon-btn--lg { width: 40px; height: 40px; }\n\n/* Metric card */\n.rt-metric-card {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-xl);\n  padding: 14px 16px 16px;\n  box-shadow: var(--shadow-xs);\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-height: 108px;\n  transition:\n    border-color var(--transition-fast),\n    box-shadow var(--transition-fast),\n    background var(--transition-fast),\n    transform var(--transition-fast);\n}\n.rt-metric-card--clickable { cursor: pointer; }\n.rt-metric-card--clickable:hover {\n  border-color: color-mix(in srgb, var(--metric-accent, var(--primary)) 40%, var(--border));\n  box-shadow: var(--shadow-sm);\n}\n.rt-metric-card__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n.rt-metric-card__meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.rt-metric-card__context {\n  font-size: var(--text-xs);\n  color: var(--text-muted);\n}\n.rt-metric-card__label {\n  font-size: var(--text-xs);\n  font-weight: var(--font-medium);\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n.rt-metric-card__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: var(--radius-md);\n  background: var(--primary-muted);\n  color: var(--primary);\n  flex-shrink: 0;\n}\n.rt-metric-card__value {\n  font-size: 1.625rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  letter-spacing: -0.03em;\n  line-height: 1.1;\n  font-variant-numeric: tabular-nums;\n}\n.rt-metric-card__footer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.rt-metric-card__trend {\n  font-size: var(--text-xs);\n  font-weight: var(--font-medium);\n}\n.rt-metric-card__trend--up { color: var(--success); }\n.rt-metric-card__trend--down { color: var(--danger); }\n.rt-metric-card__trend-label {\n  font-size: var(--text-xs);\n  color: var(--text-muted);\n}\n\n/* Section card */\n.rt-section-card {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-xs);\n  overflow: hidden;\n  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);\n}\n.rt-section-card:hover {\n  border-color: color-mix(in srgb, var(--primary) 22%, var(--border));\n  box-shadow: var(--shadow-sm);\n}\n.rt-section-card__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 20px 0;\n}\n.rt-section-card__title {\n  font-size: var(--text-lg);\n  font-weight: var(--font-semibold);\n  color: var(--text-primary);\n  margin: 0;\n}\n.rt-section-card__subtitle {\n  font-size: var(--text-sm);\n  color: var(--text-muted);\n  margin: 4px 0 0;\n}\n.rt-section-card__body { padding: 16px 20px 20px; }\n\n/* Page header */\n.rt-page-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n}\n.rt-page-header__title {\n  font-size: var(--text-3xl);\n  font-weight: var(--font-semibold);\n  color: var(--text-primary);\n  letter-spacing: -0.02em;\n  margin: 0;\n  line-height: 1.2;\n}\n.rt-page-header__subtitle {\n  font-size: var(--text-base);\n  color: var(--text-secondary);\n  margin: 6px 0 0;\n}\n.rt-page-header__actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n.rt-page-header__crumbs {\n  font-size: var(--text-sm);\n  color: var(--text-muted);\n  margin-bottom: 4px;\n}\n\n/* Badge */\n.rt-badge {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: var(--radius-full);\n  font-size: 11px;\n  font-weight: var(--font-medium);\n  letter-spacing: 0.01em;\n  white-space: nowrap;\n  text-transform: capitalize;\n}\n.rt-badge--success { background: var(--success-muted); color: var(--success); }\n.rt-badge--danger { background: var(--danger-muted); color: var(--danger); }\n.rt-badge--warning { background: var(--warning-muted); color: var(--warning); }\n.rt-badge--info { background: var(--info-muted); color: var(--info); }\n.rt-badge--muted { background: var(--bg-tertiary); color: var(--text-muted); }\n\n/* Empty / Error / Loading */\n.rt-empty-state,\n.rt-error-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 12px;\n  padding: 48px 24px;\n  min-height: 280px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  color: var(--text-primary);\n}\n\n.rt-empty-state__icon,\n.rt-error-state__icon {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: var(--bg-tertiary);\n  color: var(--text-muted);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 4px;\n}\n\n.rt-error-state__icon {\n  background: var(--danger-muted);\n  color: var(--danger);\n}\n\n.rt-empty-state__title,\n.rt-error-state__title {\n  font-size: var(--text-lg);\n  font-weight: var(--font-semibold);\n  color: var(--text-primary);\n  margin: 0;\n}\n.rt-empty-state__desc,\n.rt-error-state__desc {\n  font-size: var(--text-base);\n  color: var(--text-secondary);\n  max-width: 360px;\n  margin: 0 0 12px;\n}\n.rt-empty-state__action { margin-top: 4px; }\n\n.rt-skeleton {\n  display: block;\n  background: linear-gradient(90deg, var(--bg-tertiary) 25%, var(--surface-hover) 50%, var(--bg-tertiary) 75%);\n  background-size: 200% 100%;\n  animation: rt-shimmer 1.4s ease infinite;\n  border-radius: var(--radius-sm);\n}\n.rt-skeleton--rounded { border-radius: var(--radius-full); }\n.rt-skeleton--value { width: 72px; height: 28px; }\n.rt-loading-state { display: flex; flex-direction: column; gap: 10px; padding: 8px 0; }\n.rt-loading-state__row { width: 100%; }\n\n/* Avatar */\n.rt-avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-full);\n  background: var(--primary-muted);\n  color: var(--primary);\n  font-weight: var(--font-semibold);\n  overflow: hidden;\n  flex-shrink: 0;\n}\n.rt-avatar img { width: 100%; height: 100%; object-fit: cover; }\n.rt-avatar--sm { width: 28px; height: 28px; font-size: 11px; }\n.rt-avatar--md { width: 32px; height: 32px; font-size: 12px; }\n.rt-avatar--lg { width: 40px; height: 40px; font-size: 14px; }\n\n/* Progress */\n.rt-progress { display: flex; flex-direction: column; gap: 6px; }\n.rt-progress__meta {\n  display: flex;\n  justify-content: space-between;\n  font-size: var(--text-sm);\n  color: var(--text-secondary);\n}\n.rt-progress__track {\n  height: 8px;\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-full);\n  overflow: hidden;\n}\n.rt-progress__fill {\n  height: 100%;\n  background: var(--primary);\n  border-radius: var(--radius-full);\n  transition: width var(--transition-normal);\n}\n\n/* Table */\n.rt-table-wrap {\n  width: 100%;\n  overflow-x: auto;\n}\n.rt-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: var(--text-base);\n}\n.rt-table th {\n  text-align: left;\n  padding: 10px 14px;\n  font-size: var(--text-xs);\n  font-weight: var(--font-medium);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--text-muted);\n  border-bottom: 1px solid var(--border);\n  background: var(--bg-tertiary);\n  white-space: nowrap;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n.rt-table td {\n  padding: 12px 14px;\n  border-bottom: 1px solid var(--border-subtle);\n  color: var(--text-primary);\n  vertical-align: middle;\n}\n.rt-table tbody tr:hover { background: var(--surface-hover); }\n.rt-table__row--clickable { cursor: pointer; }\n.rt-table__align-center { text-align: center; }\n.rt-table__align-right { text-align: right; }\n\n.rt-filter-bar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n\n.rt-chart-container {\n  position: relative;\n  width: 100%;\n}\n\n@keyframes rt-spin {\n  to { transform: rotate(360deg); }\n}\n@keyframes rt-shimmer {\n  0% { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n/* Pagination */\n.rt-pagination {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 0 2px;\n  border-top: 1px solid var(--border-subtle);\n  margin-top: 12px;\n}\n\n.rt-pagination__range {\n  font-size: var(--text-sm);\n  color: var(--text-muted);\n  font-weight: 500;\n}\n\n.rt-pagination__controls {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px;\n}\n\n.rt-pagination__size {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: var(--text-sm);\n  color: var(--text-muted);\n  margin-right: 10px;\n}\n\n.rt-pagination__size select {\n  height: 32px;\n  padding: 0 8px;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--input-border);\n  background: var(--input-background);\n  color: var(--text-primary);\n  font-size: var(--text-sm);\n}\n\n.rt-pagination__btn,\n.rt-pagination__page {\n  min-width: 34px;\n  height: 34px;\n  padding: 0 10px;\n  border-radius: 999px;\n  border: 1px solid transparent;\n  background: transparent;\n  color: var(--text-secondary);\n  font-size: var(--text-sm);\n  font-weight: 550;\n  cursor: pointer;\n  transition: background 150ms ease, border-color 150ms ease, color 150ms ease, box-shadow 150ms ease;\n}\n\n.rt-pagination__btn:hover:not(:disabled),\n.rt-pagination__page:hover:not(:disabled) {\n  background: var(--surface-hover, rgba(15, 23, 42, 0.04));\n  color: var(--text-primary);\n}\n\n.rt-pagination__btn:disabled,\n.rt-pagination__page:disabled {\n  opacity: 0.38;\n  cursor: not-allowed;\n}\n\n.rt-pagination__page--active {\n  background: var(--primary-muted);\n  border-color: transparent;\n  color: var(--primary);\n  font-weight: 650;\n  box-shadow: none;\n}\n\n.rt-pagination__page--active:hover:not(:disabled) {\n  background: var(--primary-muted);\n  color: var(--primary);\n}\n\n.rt-pagination__pages {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.rt-pagination__ellipsis {\n  min-width: 24px;\n  text-align: center;\n  color: var(--text-muted);\n  font-size: var(--text-sm);\n}\n\n/* Row actions + overflow menu */\n.rt-row-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  opacity: 0.85;\n}\n\n.rt-data-table__row--clickable:hover .rt-row-actions,\n.rt-data-table tbody tr:hover .rt-row-actions {\n  opacity: 1;\n}\n\n.rt-action-menu {\n  position: fixed;\n  z-index: 1200;\n  min-width: 240px;\n  max-width: 300px;\n  padding: 6px;\n  background: var(--surface-raised, var(--surface, #fff));\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: var(--radius-lg, 10px);\n  box-shadow: var(--shadow-md, 0 4px 12px rgba(15, 23, 42, 0.08));\n  color: var(--text-primary, #0f172a);\n  -webkit-font-smoothing: antialiased;\n}\n\n[data-theme='dark'] .rt-action-menu {\n  background: var(--surface-raised, #101d30);\n  border-color: var(--border, #1d3149);\n  color: var(--text-primary, #f8fafc);\n  box-shadow: var(--shadow-md, 0 8px 24px rgba(0, 0, 0, 0.4));\n}\n\n/* One surface only — children never paint their own boxes */\n.rt-action-menu *,\n.rt-action-menu *::before,\n.rt-action-menu *::after {\n  text-shadow: none;\n  box-shadow: none;\n}\n\n.rt-action-menu__item {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  width: 100%;\n  text-align: left;\n  padding: 9px 10px;\n  margin: 0;\n  border: none;\n  border-radius: var(--radius-md, 8px);\n  background: transparent;\n  color: inherit;\n  font-size: var(--text-sm, 0.875rem);\n  font-family: inherit;\n  cursor: pointer;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.rt-action-menu__item:hover:not(:disabled),\n.rt-action-menu__item:focus-visible:not(:disabled) {\n  background: rgba(59, 130, 246, 0.08);\n  outline: none;\n}\n\n[data-theme='dark'] .rt-action-menu__item:hover:not(:disabled),\n[data-theme='dark'] .rt-action-menu__item:focus-visible:not(:disabled) {\n  background: rgba(59, 130, 246, 0.12);\n}\n\n.rt-action-menu__item:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.rt-action-menu__item--danger {\n  color: var(--danger, #dc2626);\n}\n\n[data-theme='dark'] .rt-action-menu__item--danger {\n  color: #fb7185;\n}\n\n.rt-action-menu__item--danger:hover:not(:disabled) {\n  background: var(--danger-muted, rgba(220, 38, 38, 0.12));\n}\n\n.rt-action-menu__icon {\n  display: inline-flex;\n  flex-shrink: 0;\n  margin-top: 2px;\n  color: var(--text-muted, #64748b);\n  background: transparent;\n  border: none;\n}\n\n.rt-action-menu__item--danger .rt-action-menu__icon {\n  color: inherit;\n}\n\n.rt-action-menu__text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  background: transparent;\n  border: none;\n  padding: 0;\n}\n\n.rt-action-menu__label {\n  font-weight: 600;\n  line-height: 1.3;\n  background: transparent;\n  border: none;\n  padding: 0;\n}\n\n.rt-action-menu__desc {\n  font-size: 11px;\n  font-weight: 400;\n  color: var(--text-muted, #64748b);\n  line-height: 1.35;\n  background: transparent;\n  border: none;\n  padding: 0;\n}\n\n.rt-action-menu__divider {\n  height: 1px;\n  margin: 5px 8px;\n  background: var(--border-subtle, var(--border, #e2e8f0));\n  border: none;\n  box-shadow: none;\n}\n\n[data-theme='dark'] .rt-action-menu__divider {\n  background: var(--border, #1d3149);\n}\n\n/* Flat typography — no accidental text glow across product UI */\n.rt2-main,\n.rt2-main *,\n.rt-action-menu,\n.rt-action-menu *,\n[data-rt-modal-overlay],\n[data-rt-modal-overlay] * {\n  text-shadow: none;\n}\n\n/* Text wrappers never invent their own surface */\n.rt2-main p,\n.rt2-main h1,\n.rt2-main h2,\n.rt2-main h3,\n.rt2-main h4,\n.rt2-main h5,\n.rt2-main h6,\n.rt2-main label,\n.rt2-main small,\n.rt2-main strong,\n.rt2-main em,\n.rt2-main li {\n  background: transparent;\n  box-shadow: none;\n}\n/* Context summary strip */\n.rt-context-strip {\n  display: grid;\n  grid-template-columns: minmax(180px, 1.4fr) repeat(auto-fit, minmax(100px, 1fr));\n  gap: 12px;\n  padding: 14px 16px;\n  margin-bottom: 14px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  align-items: center;\n}\n\n.rt-context-strip__title {\n  margin: 0;\n  font-size: var(--text-lg);\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.rt-context-strip__meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 6px;\n}\n\n.rt-context-strip__stat-label {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--text-muted);\n  font-weight: 600;\n}\n\n.rt-context-strip__stat-value {\n  font-size: 1.15rem;\n  font-weight: 650;\n  color: var(--text-primary);\n  letter-spacing: -0.02em;\n}\n\n/* Filter chips */\n.rt-filter-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 8px 0 4px;\n}\n\n.rt-filter-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 28px;\n  padding: 0 10px;\n  border-radius: 999px;\n  background: var(--primary-muted);\n  color: var(--primary);\n  font-size: var(--text-xs);\n  font-weight: 600;\n  border: none;\n}\n\n.rt-filter-chip button {\n  border: none;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n  padding: 0;\n  font-size: 14px;\n  line-height: 1;\n}\n\n.rt-table-skeleton td {\n  padding: 12px 10px;\n}\n\n.rt-table-skeleton .rt-skeleton {\n  height: 14px;\n  width: 100%;\n}\n\n\n/* ── Select (canonical custom select) ─────────────────────────────── */\n.rt-select {\n  position: relative;\n  display: inline-flex;\n  flex: 0 0 auto;\n  min-width: 140px;\n  max-width: 100%;\n  width: auto;\n  vertical-align: middle;\n}\n\n/* Compact selects inside FilterBar / toolbars — stay on one row with search */\n.rt-select--filter {\n  flex: 0 0 auto;\n  width: auto;\n  min-width: 132px;\n  max-width: 200px;\n}\n\n.rt-filter-bar > .rt-select,\n.rt-filter-bar > .rt-select--filter {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 200px;\n}\n\n.rt-filter-bar > .rt-search {\n  flex: 1 1 220px;\n  max-width: 360px;\n  min-width: 180px;\n}\n\n.rt-select--form {\n  display: flex;\n  width: 100%;\n  max-width: none;\n}\n\n.rt-select__trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  height: var(--control-height, 36px);\n  padding: 0 10px 0 12px;\n  border: 1px solid var(--input-border);\n  border-radius: var(--radius-md);\n  background: var(--input-background);\n  color: var(--text-primary);\n  font: inherit;\n  font-size: var(--text-sm);\n  font-weight: 500;\n  text-align: left;\n  cursor: pointer;\n  transition: border-color var(--duration-fast, 120ms) ease, box-shadow var(--duration-fast, 120ms) ease,\n    background var(--duration-fast, 120ms) ease;\n}\n\n.rt-select--form .rt-select__trigger {\n  height: 40px;\n  font-weight: 400;\n  font-size: var(--text-base);\n}\n\n.rt-select--sm .rt-select__trigger {\n  height: var(--control-height-sm, 30px);\n  padding: 0 6px 0 10px;\n}\n\n.rt-select--sm {\n  min-width: 72px;\n}\n\n.rt-select__trigger:hover:not(:disabled) {\n  border-color: var(--border-strong);\n}\n\n.rt-select__trigger:focus-visible,\n.rt-select.is-open .rt-select__trigger {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: var(--shadow-focus);\n}\n\n.rt-select.is-invalid .rt-select__trigger {\n  border-color: var(--danger);\n}\n\n.rt-select__trigger:disabled {\n  cursor: not-allowed;\n  background: var(--surface-disabled);\n  color: var(--text-muted);\n}\n\n.rt-select__value {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rt-select__value.is-placeholder {\n  color: var(--text-muted);\n}\n\n.rt-select__chevron {\n  flex-shrink: 0;\n  color: var(--text-muted);\n  transition: transform var(--duration-normal, 200ms) var(--ease-out, ease);\n}\n\n.rt-select.is-open .rt-select__chevron {\n  transform: rotate(180deg);\n}\n\n.rt-select__menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  /* For in-flow menus, match trigger. Portaled menus must NOT use\n     min-width: 100% — fixed positioning resolves % against the viewport. */\n  min-width: 100%;\n  box-sizing: border-box;\n  z-index: var(--z-dropdown, 1200);\n  margin: 0;\n  padding: 4px;\n  list-style: none;\n  max-height: 300px;\n  overflow-y: auto;\n  background: var(--surface-elevated);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  animation: rt-pop-in var(--duration-fast, 120ms) var(--ease-out, ease);\n}\n\n.rt-select__menu.is-up:not(.rt-select__menu--portal) {\n  top: auto;\n  bottom: calc(100% + 4px);\n}\n\n.rt-select__menu--portal {\n  position: fixed;\n  z-index: 10050;\n  /* width / minWidth come from inline style measured against the trigger */\n  min-width: 0;\n  max-width: min(100vw - 16px, 480px);\n}\n\n.rt-select__option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  min-height: 34px;\n  padding: 6px 10px;\n  border-radius: var(--radius-sm);\n  font-size: var(--text-sm);\n  color: var(--text-primary);\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.rt-select__option.is-active {\n  background: var(--surface-hover);\n}\n\n.rt-select__option.is-selected {\n  color: var(--primary);\n  font-weight: 600;\n}\n\n.rt-select__option.is-placeholder {\n  color: var(--text-muted);\n}\n\n.rt-select__option[aria-disabled='true'] {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.rt-select__option-hint {\n  font-size: 11px;\n  color: var(--text-muted);\n}\n\n.rt-select__empty {\n  padding: 10px;\n  font-size: var(--text-sm);\n  color: var(--text-muted);\n}\n\n@keyframes rt-pop-in {\n  from { opacity: 0; transform: translateY(-3px) scale(0.985); }\n  to { opacity: 1; transform: none; }\n}\n\n/* ── Action menu sections ─────────────────────────────────────────── */\n.rt-action-menu {\n  z-index: 10050;\n  animation: rt-pop-in var(--duration-fast, 120ms) var(--ease-out, ease);\n  background: var(--surface-elevated);\n  box-shadow: var(--shadow-lg);\n}\n\n[data-theme='dark'] .rt-action-menu {\n  background: var(--surface-elevated);\n  box-shadow: var(--shadow-lg);\n}\n\n.rt-action-menu__group {\n  padding: 6px 10px 4px;\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n.rt-action-menu__item:focus-visible {\n  outline: none;\n  box-shadow: inset 0 0 0 2px var(--primary-muted) !important;\n}\n\n/* ── Empty / error states ─────────────────────────────────────────── */\n.rt-state__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  margin-bottom: 4px;\n  border-radius: 12px;\n  background: var(--bg-tertiary);\n  color: var(--text-muted);\n  border: 1px solid var(--border-subtle);\n}\n\n.rt-state--error .rt-state__icon {\n  background: var(--danger-muted);\n  color: var(--danger);\n  border-color: transparent;\n}\n\n/* ── Pagination refinements ───────────────────────────────────────── */\n.rt-pagination__btn,\n.rt-pagination__page {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-variant-numeric: tabular-nums;\n}\n\n.rt-pagination__range {\n  font-variant-numeric: tabular-nums;\n}\n\n.rt-pagination__btn:focus-visible,\n.rt-pagination__page:focus-visible {\n  outline: none;\n  box-shadow: var(--shadow-focus);\n  border-color: var(--primary);\n}\n\n@media (max-width: 640px) {\n  .rt-pagination {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .rt-pagination__controls {\n    justify-content: space-between;\n  }\n\n  .rt-pagination__btn[aria-label='First page'],\n  .rt-pagination__btn[aria-label='Last page'] {\n    display: none;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .rt-select__menu,\n  .rt-action-menu,\n  .rt-select__chevron {\n    animation: none;\n    transition: none;\n  }\n}\n\n/* ── Utilities ─────────────────────────────────────────── */\n.rt-visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  white-space: nowrap;\n}\n\n.rt-num { font-variant-numeric: tabular-nums; }\n\n.rt-spin { animation: rt-spin 0.9s linear infinite; }\n@keyframes rt-spin { to { transform: rotate(360deg); } }\n\n.rt-btn > svg { vertical-align: -2px; }\n\n/* ── Sortable table header ─────────────────────────────── */\n.rt-sort-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 2px 4px;\n  margin: -2px -4px;\n  border: none;\n  border-radius: 4px;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  letter-spacing: inherit;\n  text-transform: inherit;\n  cursor: pointer;\n}\n.rt-sort-btn svg { opacity: 0.35; transition: opacity var(--transition-fast); }\n.rt-sort-btn:hover { color: var(--text-primary); background: var(--surface-hover); }\n.rt-sort-btn:hover svg,\n.rt-sort-btn--active svg { opacity: 1; }\n.rt-sort-btn--active { color: var(--primary); }\n.rt-sort-btn:focus-visible { outline: 2px solid var(--primary); outline-offset: 1px; }\n\n/* ── Filter chips ──────────────────────────────────────── */\n.rt-chip-group {\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n.rt-chip {\n  --chip-accent: var(--primary);\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 30px;\n  padding: 0 10px;\n  border: 1px solid var(--border);\n  border-radius: 999px;\n  background: var(--surface);\n  color: var(--text-secondary);\n  font-size: 12.5px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: border-color var(--transition-fast), background var(--transition-fast), color var(--transition-fast);\n}\n.rt-chip--passed { --chip-accent: var(--success); }\n.rt-chip--failed { --chip-accent: var(--danger); }\n.rt-chip--running { --chip-accent: var(--info); }\n.rt-chip:hover { border-color: color-mix(in srgb, var(--chip-accent) 45%, var(--border)); color: var(--text-primary); }\n.rt-chip--active {\n  border-color: color-mix(in srgb, var(--chip-accent) 60%, transparent);\n  background: color-mix(in srgb, var(--chip-accent) 12%, var(--surface));\n  color: var(--text-primary);\n}\n.rt-chip:focus-visible { outline: 2px solid var(--chip-accent); outline-offset: 2px; }\n.rt-chip__dot { width: 7px; height: 7px; border-radius: 50%; background: var(--chip-accent); }\n.rt-chip__count {\n  min-width: 18px;\n  padding: 0 5px;\n  border-radius: 999px;\n  background: var(--surface-hover, rgba(148, 163, 184, 0.14));\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 18px;\n  text-align: center;\n  font-variant-numeric: tabular-nums;\n}\n.rt-chip--active .rt-chip__count { background: color-mix(in srgb, var(--chip-accent) 22%, transparent); }\n.rt-chip--scheduled { --chip-accent: var(--info); }\n.rt-chip--pending { --chip-accent: var(--warning); }\n.rt-chip--completed { --chip-accent: var(--success); }\n.rt-chip--cancelled { --chip-accent: var(--text-muted); }\n\n/* ── Schedules ─────────────────────────────────────────── */\n.rt-sched-panel { display: grid; gap: 12px; }\n.rt-sched-panel__actions { display: flex; justify-content: flex-end; gap: 8px; }\n.rt-sched-table { display: grid; gap: 12px; transition: opacity 150ms ease; }\n.rt-sched-table[aria-busy='true'] { opacity: 0.6; }\n.rt-sched-name,\n.rt-sched-time { display: grid; gap: 2px; min-width: 0; }\n.rt-sched-name__title { font-weight: 600; color: var(--text-primary); }\n.rt-sched-sub {\n  max-width: 280px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: var(--text-xs, 12px);\n  color: var(--text-muted);\n}\n.rt-sched-sub--plain { font-size: inherit; color: var(--text-secondary); }\n@media (prefers-reduced-motion: reduce) {\n  .rt-sched-table { transition: none; }\n}\n\n/* ── Test result bar ───────────────────────────────────── */\n.rt-result { display: grid; gap: 5px; min-width: 150px; }\n.rt-result__bar {\n  display: flex;\n  height: 6px;\n  border-radius: 999px;\n  overflow: hidden;\n  background: var(--border);\n}\n.rt-result__seg { height: 100%; transition: width var(--duration-slow, 280ms) var(--ease-out, ease-out); }\n.rt-result__seg--pass { background: var(--success); }\n.rt-result__seg--fail { background: var(--danger); }\n.rt-result__seg--skip { background: var(--warning); }\n.rt-result__meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 2px 8px;\n  font-size: 11.5px;\n  font-variant-numeric: tabular-nums;\n}\n.rt-result__pass { color: var(--success); font-weight: 600; }\n.rt-result__fail { color: var(--danger); font-weight: 600; }\n.rt-result__zero { color: var(--text-muted); }\n.rt-result__total { color: var(--text-muted); }\n.rt-result__rate { margin-left: auto; font-weight: 600; color: var(--text-primary); }\n\n/* ── Executions table ──────────────────────────────────── */\n.rt-exec-name__title { font-weight: 600; }\n.rt-exec-updated { font-size: 12px; align-self: center; }\n.rt-exec-open {\n  display: inline-flex;\n  color: var(--text-muted);\n  opacity: 0;\n  transform: translateX(-4px);\n  transition: opacity var(--transition-fast), transform var(--transition-fast), color var(--transition-fast);\n}\n.rt-data-table__row--clickable:hover .rt-exec-open {\n  opacity: 1;\n  transform: none;\n  color: var(--primary);\n}\n.rt-exec-status--live .rt-status-dot { animation: rt-live-pulse 1.4s ease-in-out infinite; }\n@keyframes rt-live-pulse {\n  0%, 100% { box-shadow: 0 0 0 0 color-mix(in srgb, currentColor 45%, transparent); }\n  50% { box-shadow: 0 0 0 4px transparent; }\n}\n\n.rt-metric-card.rt-metric-card--active {\n  border-color: color-mix(in srgb, var(--metric-accent, var(--primary)) 65%, transparent);\n  background: color-mix(in srgb, var(--metric-accent, var(--primary)) 7%, var(--surface));\n}\n.rt-metric-card--pulse .rt-metric-card__value::after {\n  content: '';\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  margin-left: 8px;\n  border-radius: 50%;\n  background: var(--metric-accent);\n  vertical-align: middle;\n  animation: rt-live-pulse 1.4s ease-in-out infinite;\n  color: var(--metric-accent);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .rt-spin,\n  .rt-exec-status--live .rt-status-dot,\n  .rt-metric-card--pulse .rt-metric-card__value::after { animation: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
